import React, { useEffect, useState } from "react";
import { fetchToken } from "../../../../features/common/FetchCookie";
import { DummyAfterLogin } from "./DummyAfterLogin";
import EmployerHome from "../../../EmployerHomePage/EmployerWithoutLoggedIn";

const DummyPage = () => {
  const [isLogin, setIsLogin] = useState(false);

  useEffect(() => {
    const fetchingToken = async () => {
      const token = await fetchToken();
      if (token) {
        setIsLogin(true);
      } else {
        setIsLogin(false);
      }
    };
    fetchingToken();
  }, []); // Remove `isLogin` from dependency array to avoid re-running the effect unnecessarily

  return <div>{isLogin ? <DummyAfterLogin /> : <EmployerHome />}</div>;
};

export default DummyPage;
